/**
 * WebKit (F36): um nó sem referência no JavaScript (o oscilador que já tocou) pode ser liberado
 * enquanto o contexto offline ainda renderiza, e a página cai (`AudioSummingJunction::
 * updateRenderingState`, chamada virtual pura; visto nos e2e ao abrir o jogo). Guarda cada nó criado
 * neste contexto até o fim do render (o chamador esvazia a lista).
 */
export function retainNodes(ctx: BaseAudioContext): AudioNode[] {
  const kept: AudioNode[] = [];
  const target = ctx as unknown as Record<string, unknown>;
  for (const name of Object.getOwnPropertyNames(BaseAudioContext.prototype)) {
    if (!name.startsWith("create") || name === "createBuffer" || name === "createPeriodicWave") continue;
    const original = target[name];
    if (typeof original !== "function") continue;
    target[name] = (...args: unknown[]) => {
      const node = (original as (...a: unknown[]) => AudioNode).apply(ctx, args);
      kept.push(node);
      return node;
    };
  }
  return kept;
}
